import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
	/**
	 * Specify your server-side environment variables schema here. This way you can ensure the app
	 * isn't built with invalid env vars.
	 */
	server: {
		NODE_ENV: z.enum(['development', 'test', 'production']),
		AXIOM_TOKEN: z.string().default(''),
		AXIOM_DATASET: z.string().default(''),
		CLERK_SECRET_KEY: z.string(),
		INTERNAL_API_SECRET: z.string().min(32),
	},

	/**
	 * Specify your client-side environment variables schema here. This way you can ensure the app
	 * isn't built with invalid env vars. To expose them to the client, prefix them with
	 * `NEXT_PUBLIC_`.
	 */
	client: {
		NEXT_PUBLIC_FRONTEND_URL: z.string().url(),
		NEXT_PUBLIC_SHORT_URL_DOMAIN: z.string().url().optional(),
		NEXT_PUBLIC_API_URL: z.string().url(),
		NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: z.string(),
		NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
		NEXT_PUBLIC_POSTHOG_HOST: z.string().optional(),
		NEXT_PUBLIC_SENTRY_DSN: z.string().default(''),
		NEXT_PUBLIC_SENTRY_ENVIRONMENT: z.string().default('production'),
		NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_MONTHLY: z.string().default(''),
		NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_ANNUAL: z.string().default(''),
		NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_MONTHLY_LEGACY: z.string().optional(),
		NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_ANNUAL_LEGACY: z.string().optional(),
		NEXT_PUBLIC_STRIPE_ADDON_DOMAIN_PRICE_ID_MONTHLY: z.string().default(''),
		NEXT_PUBLIC_STRIPE_ADDON_DOMAIN_PRICE_ID_ANNUAL: z.string().default(''),
		NEXT_PUBLIC_GOOGLE_API_KEY: z.string().default(''),
		NEXT_PUBLIC_CLERK_JS_URL: z.string(),
	},

	/**
	 * You can't destruct `process.env` as a regular object in the Next.js edge runtimes (e.g.
	 * middlewares) or client-side so we need to destruct manually.
	 */
	runtimeEnv: {
		NODE_ENV: process.env.NODE_ENV,
		NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
		AXIOM_TOKEN: process.env.AXIOM_TOKEN,
		AXIOM_DATASET: process.env.AXIOM_DATASET,
		CLERK_SECRET_KEY: process.env.CLERK_SECRET_KEY,

		NEXT_PUBLIC_FRONTEND_URL: process.env.NEXT_PUBLIC_FRONTEND_URL,
		NEXT_PUBLIC_SHORT_URL_DOMAIN: process.env.NEXT_PUBLIC_SHORT_URL_DOMAIN,
		NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
		NEXT_PUBLIC_SENTRY_ENVIRONMENT: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
		NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
		NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
		NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
		NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_MONTHLY: process.env.NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_MONTHLY,
		NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_ANNUAL: process.env.NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_ANNUAL,
		NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_MONTHLY_LEGACY:
			process.env.NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_MONTHLY_LEGACY,
		NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_ANNUAL_LEGACY:
			process.env.NEXT_PUBLIC_STRIPE_PRO_PRICE_ID_ANNUAL_LEGACY,
		NEXT_PUBLIC_STRIPE_ADDON_DOMAIN_PRICE_ID_MONTHLY:
			process.env.NEXT_PUBLIC_STRIPE_ADDON_DOMAIN_PRICE_ID_MONTHLY,
		NEXT_PUBLIC_STRIPE_ADDON_DOMAIN_PRICE_ID_ANNUAL:
			process.env.NEXT_PUBLIC_STRIPE_ADDON_DOMAIN_PRICE_ID_ANNUAL,
		INTERNAL_API_SECRET: process.env.INTERNAL_API_SECRET,
		NEXT_PUBLIC_GOOGLE_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_API_KEY,
		NEXT_PUBLIC_CLERK_JS_URL: process.env.NEXT_PUBLIC_CLERK_JS_URL,
	},
	/**
	 * Run `build` or `dev` with `SKIP_ENV_VALIDATION` to skip env validation. This is especially
	 * useful for Docker builds.
	 */
	skipValidation: !!process.env.SKIP_ENV_VALIDATION,
	/**
	 * Makes it so that empty strings are treated as undefined. `SOME_VAR: z.string()` and
	 * `SOME_VAR=''` will throw an error.
	 */
	emptyStringAsUndefined: true,
});
